
import React, { useMemo } from 'react'
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs'
import { LocalizationProvider, DateRangePicker } from '@mui/x-date-pickers-pro'
import dayjs, { Dayjs } from 'dayjs'
import { Box, useTheme } from '@mui/material'

interface DateRangeProps {
  value: [string | null, string | null]
  onChange: (range: [string, string]) => void
  disabled?: boolean
}

const DateRangePickerComponent: React.FC<DateRangeProps> = ({ value, onChange, disabled }) => {
  const theme = useTheme()

  const parsedValue = useMemo(() => {
    return [value[0] ? dayjs(value[0]) : null, value[1] ? dayjs(value[1]) : null] as [Dayjs | null, Dayjs | null]
  }, [value[0], value[1]])

  const handleRangeChange = (newRange: [Dayjs | null, Dayjs | null]) => {
    if (newRange[0] && newRange[1]) {
      onChange([newRange[0].toISOString(), newRange[1].toISOString()])
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
        <DateRangePicker
          localeText={{ start: 'Start Date', end: 'Due Date' }}
          value={parsedValue}
          onChange={handleRangeChange}
          sx={{
            width: '100%',
            '& .MuiMultiInputDateRangeField-separator': { m: 0 },
            '& .MuiFormControl-root': { m: 0 },
            '& .MuiInputBase-root': {
              bgcolor: disabled ? theme.palette.background.disabled : '',
              maxHeight: '45px',
              m: 0,
            },
          }}
          disabled={disabled}
        />
      </Box>
    </LocalizationProvider>
  )
}

export default DateRangePickerComponent
